import React, { useEffect } from "react";
import getAuthorization from "./helpers/getAuthorization";
import { useRouter } from "next/router";
import { useVerifyQuery } from "./generated/graphql";
import { Loading } from "@kiwicom/orbit-components";
import safeRedirect from "./helpers/safeRedirect";
import { getLoginUrl } from "./helpers/getLoginUrl";
import { removeAuthorization } from "./helpers/removeAuthorization";
import queryString from "query-string";
import storeAuthorization from "./helpers/storeAuthorization";

const hasPrivateRoute = url => url.includes("/private");

const PrivateRoutes = ({ children, isExport }) => {
  const { token: appToken } = getAuthorization();

  const router = useRouter();
  const isPrivate = hasPrivateRoute(router.route);

  const queryToken = router.query.token;

  const token = queryToken || appToken;

  const { loading, data, error, refetch } = useVerifyQuery({
    variables: {
      token
    },
    skip: !token && isPrivate === false,
    fetchPolicy: "no-cache"
  });

  useEffect(() => {
    if (isPrivate) {
      refetch();
    }
  }, [refetch, router, isPrivate]);

  if (!isPrivate) return children;

  if (loading) {
    return <Loading />;
  }

  if (error) {
    const redirectUrl = queryString.stringifyUrl({
      url: getLoginUrl(isExport),
      query: {
        returnUrl: window.location.href,
        error: "Platnost Vašeho přihlášení vypršela"
      }
    });

    removeAuthorization();
    safeRedirect(redirectUrl);
    return null;
  }

  if (data && queryToken) {
    storeAuthorization(queryToken);
  }

  if (data) {
    return children;
  }

  return null;
};

export default PrivateRoutes;
